export default "__VITE_ASSET__DB6RZJns__"